import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { EnterpriseSharedService } from '../../services/enterprise-shared.service';
import { FeaturesService } from '../../services/features.service';
import { EnterpriseAccessAreaService } from '../../services/enterprise-access-area.service';
import { EnterpriseDto, DevToolService } from 'lib';
import { NgIf } from '@angular/common';

@Component({
    selector: 'mmoga-enterprise-management',
    standalone: true,
    imports: [RouterLink, RouterOutlet, RouterLinkActive, NgIf],
    templateUrl: './enterprise-management.component.html',
    styleUrl: './enterprise-management.component.scss'
})
export class EnterpriseManagementComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private enterpriseSharedService = inject(EnterpriseSharedService);
    private readonly devToolService = inject(DevToolService);
    private readonly featuresService = inject(FeaturesService);
    private readonly enterpriseAccessAreaService = inject(EnterpriseAccessAreaService);

    enterpriseId: string | null = null;
    isCreateMode = false;
    enterpriseName = '';
    isDevtoolEnabled = false;
    isRcmAiPlatformEnabled = false;
    /** At least one RBAC product is configured, so Applications has an Enhance Authorization card to show. */
    hasAccessAreas = false;

    constructor() {
        this.isDevtoolEnabled = this.devToolService.validateAccess();
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.enterpriseId = params[ 'id' ] || null;
            this.isCreateMode = !this.enterpriseId;
            this.checkAccessAreas();
        });

        this.enterpriseSharedService.enterprise$.subscribe((enterprise: EnterpriseDto | null) => {
            if (enterprise) {
                this.enterpriseName = enterprise.name;
            }
        });

        this.featuresService.getFeatureFlags().subscribe({
            next: flags => this.isRcmAiPlatformEnabled = flags.rcmAiPlatformEnabled,
            error: () => this.isRcmAiPlatformEnabled = false
        });
    }

    /**
     * Shows Applications for at least one RBAC product. A real failure (a 404 already counts as none) keeps the tab, so the card can show
     * its error and Retry. Answers for an enterprise that is no longer shown are ignored.
     */
    private checkAccessAreas(): void {
        this.hasAccessAreas = false;
        const enterpriseId = this.enterpriseId;
        if (enterpriseId) {
            this.enterpriseAccessAreaService.getAccessAreas(Number(enterpriseId)).subscribe({
                next: areas => {
                    if (enterpriseId === this.enterpriseId) {
                        this.hasAccessAreas = areas.length > 0;
                    }
                },
                error: () => {
                    if (enterpriseId === this.enterpriseId) {
                        this.hasAccessAreas = true;
                    }
                }
            });
        }
    }
}
